import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import { ListItem } from 'components/shared/List/styles'
import { useIntl } from 'react-intl'

const Instructions = () => {
    const { formatMessage } = useIntl()
    const instructionPoints = [
        formatMessage({
            id: 'annual.add_photo_instructions.list_item_up_to_date_photo',
            defaultMessage: 'Zdjęcie powinno być aktualne',
        }),
        formatMessage({
            id: 'annual.add_photo_instructions.list_item_full_face_photo',
            defaultMessage:
                'Zdjęcie powinno przedstawiać całą głowę - twarz powinna być dobrze widoczna',
        }),
        formatMessage({
            id: 'annual.add_photo_instructions.list_item_one_person_photo',
            defaultMessage: 'Na zdjęciu może być jedna osoba',
        }),
        formatMessage({
            id: 'annual.add_photo_instructions.dimensions_photo',
            defaultMessage:
                'Minimalna rozdzielczość zdjęcia to 492 x 633 piksele',
        }),
    ]
    return (
        <Box>
            <Box gap={[24, 16]} pb={[24, 40]}>
                <Text variant="heading3">
                    {formatMessage({
                        id: 'annual.add_photo_instructions.title',
                        defaultMessage: 'Wybierz zdjęcie',
                    })}
                </Text>
                <Text variant={'body'} color="grayscale_900" mb={[0, 8]}>
                    {formatMessage({
                        id: 'annual.add_photo_instructions.description',
                        defaultMessage:
                            'Zdjęcie umieścimy na Twojej karcie – będzie ono służyć do identyfikacji i zapobiegania nadużyciom.',
                    })}
                </Text>
                {/* {isTablet && <PictureUploader />} */}
                <Box gap={[16, 12]}>
                    <Text variant="bodyStrong" color="grayscale_900">
                        {formatMessage({
                            id: 'annual.add_photo_instructions.tips_list_title',
                            defaultMessage: 'Wytyczne dla zdjęcia:',
                        })}
                    </Text>
                    {instructionPoints.map((item, index) => (
                        <ListItem
                            backgroundColor="primary_500"
                            direction="row"
                            align={['flex-start', 'center']}
                            key={index}
                            gap={8}
                        >
                            <Text variant="body" color="grayscale_900">
                                {item}
                            </Text>
                        </ListItem>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default Instructions
